import { X, Heart, ShoppingCart, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatPrice } from "./shopData";

export default function WishlistSidebar({ wishlist, isOpen, onClose, onAddToCart, onOpenProduct }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[9999]" data-testid="wishlist-sidebar">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <aside className="absolute right-0 top-0 bottom-0 w-full sm:w-[420px] bg-[#0a0a0a] border-l border-[#1E1E1E] shadow-2xl flex flex-col">
        <header className="flex items-center justify-between px-5 py-4 border-b border-[#1E1E1E]">
          <div className="flex items-center gap-2">
            <Heart size={18} className="text-[#FF3B30]" fill="#FF3B30" />
            <h2 className="text-white font-bold text-base">Verlanglijst</h2>
            {wishlist.items.length > 0 && (
              <span className="bg-[#FF3B30]/20 text-[#FF3B30] text-[10px] font-bold px-2 py-0.5 rounded-full">
                {wishlist.count}
              </span>
            )}
          </div>
          <button onClick={onClose} className="text-[#666] hover:text-white transition-colors" data-testid="wishlist-close">
            <X size={20} />
          </button>
        </header>

        <div className="flex-1 overflow-y-auto">
          {wishlist.items.length === 0 ? (
            <div className="p-8 text-center">
              <Heart size={44} className="mx-auto text-[#333] mb-4" />
              <p className="text-white font-semibold mb-1">Je verlanglijst is leeg</p>
              <p className="text-[#666] text-sm">Klik op het ♥ icoon bij een product om het hier op te slaan.</p>
            </div>
          ) : (
            <ul className="divide-y divide-[#1E1E1E]">
              {wishlist.items.map((it) => (
                <li key={it.slug} className="p-4 flex gap-3 group" data-testid={`wishlist-item-${it.slug}`}>
                  <button
                    className="w-16 h-16 bg-white rounded-md overflow-hidden flex-shrink-0 flex items-center justify-center border border-[#1E1E1E]"
                    onClick={() => { onClose(); onOpenProduct && onOpenProduct(it); }}
                    title="Bekijk product"
                  >
                    {it.image_url ? (
                      <img src={it.image_url} alt={it.title} className="w-full h-full object-contain" />
                    ) : (
                      <span className="text-[#999] text-[9px] font-bold px-1 text-center leading-tight">{it.brand || "TTW"}</span>
                    )}
                  </button>
                  <div className="flex-1 min-w-0">
                    <button
                      className="text-white text-sm font-semibold truncate text-left hover:text-[#FF3B30] transition-colors block w-full"
                      onClick={() => { onClose(); onOpenProduct && onOpenProduct(it); }}
                    >
                      {it.title}
                    </button>
                    <p className="text-[#666] text-[11px] truncate">
                      {it.brand}{it.car_make ? ` · ${it.car_make}` : ""}{it.car_model ? ` ${it.car_model}` : ""}
                    </p>
                    <p className="text-[#FF3B30] font-bold text-sm mt-1">{formatPrice(it.price)}</p>
                  </div>
                  <div className="flex flex-col gap-1.5 items-end">
                    <button
                      onClick={() => onAddToCart && onAddToCart(it)}
                      className="text-[#27AE60] hover:text-white text-[11px] font-semibold whitespace-nowrap inline-flex items-center gap-1 px-2 py-1 rounded border border-[#27AE60]/30 hover:bg-[#27AE60]"
                      data-testid={`wishlist-add-cart-${it.slug}`}
                      title="In winkelwagen"
                    >
                      <ShoppingCart size={12} /> Kopen
                    </button>
                    <button
                      onClick={() => wishlist.remove(it.slug)}
                      className="text-[#666] hover:text-[#E74C3C] p-1"
                      data-testid={`wishlist-remove-${it.slug}`}
                      title="Verwijderen"
                    >
                      <Trash2 size={13} />
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {wishlist.items.length > 0 && (
          <footer className="p-4 border-t border-[#1E1E1E] space-y-2">
            <Button
              className="w-full bg-[#27AE60] hover:bg-[#229953] text-white font-bold"
              onClick={() => {
                wishlist.items.forEach((it) => onAddToCart && onAddToCart(it));
                onClose();
              }}
              data-testid="wishlist-add-all-cart"
            >
              <ShoppingCart size={15} className="mr-2" />
              Alles in winkelwagen
            </Button>
            <button
              onClick={() => { if (window.confirm("Verlanglijst leegmaken?")) wishlist.clear(); }}
              className="w-full text-[#666] hover:text-[#E74C3C] text-xs py-1 transition-colors"
              data-testid="wishlist-clear"
            >
              Lijst leegmaken
            </button>
          </footer>
        )}
      </aside>
    </div>
  );
}
